const swiper = new Swiper('.js-categories-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 80,
  breakpoints: {
    320: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    500: {
      slidesPerView: 'auto',
      spaceBetween: 30,
    },
    765: {
      slidesPerView: 'auto',
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 'auto',
      spaceBetween: 80,
    },
  },
  setWrapperSize: true,
  freeMode: {
    enabled: true,
  },
});
